<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>从业劳务所得税</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">从业劳务所得税</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="4">
                <el-form-item label="年份">
                  <div style="display: flex; align-items: center;">
                    <el-select
                      v-model="ruleForm.year"
                      placeholder="选择年份"
                      style="margin-right: auto"
                    >
                      <el-option label="2025年" value="2025"></el-option>
                      <el-option label="2026年" value="2026"></el-option>
                      <el-option label="2027年" value="2027"></el-option>
                      <el-option label="2028年" value="2028"></el-option>
                      <el-option label="2029年" value="2029"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="月份">
                  <div style="display: flex; align-items: center;">
                    <el-select
                      v-model="ruleForm.mounth"
                      placeholder="选择月份"
                      style="margin-right: auto"
                    >
                      <el-option label="1月" value="1"></el-option>
                      <el-option label="2月" value="2"></el-option>
                      <el-option label="3月" value="3"></el-option>
                      <el-option label="4月" value="4"></el-option>
                      <el-option label="5月" value="5"></el-option>
                      <el-option label="6月" value="6"></el-option>
                      <el-option label="7月" value="7"></el-option>
                      <el-option label="8月" value="8"></el-option>
                      <el-option label="9月" value="9"></el-option>
                      <el-option label="10月" value="10"></el-option>
                      <el-option label="11月" value="11"></el-option>
                      <el-option label="12月" value="12"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="待申报" value="0"></el-option>
                    <el-option label="已申报" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="InvoicingAll()" class="btn"
            >批量申报</el-button
          >
          <el-button type="primary" @click="dowon()" class="btn"
            >税务申报模板下载</el-button
          >
          <el-button type="primary" @click="exportList()" class="btn"
            >导出申报excel</el-button
          >
        </div>
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="taxBatchNo" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="taxMonth" label="月份" align="center">
          </el-table-column>
          <el-table-column prop="taxpayerName" label="姓名" align="center">
          </el-table-column>
          <el-table-column
            prop="taxpayerCertTypeName"
            label="证件类型"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="taxpayerCertCode"
            label="证件编号"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="incomeProject" label="所得项目" align="center">
          </el-table-column>
          <el-table-column prop="changeIncome" label="本期收入" align="center">
          </el-table-column>
          <el-table-column
            prop="currentTaxFreeIncome"
            label="本期免税收入"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="annuity" label="累计个人养老金" align="center">
          </el-table-column>
          <el-table-column
            prop="commercialHealthInsurance"
            label="商业健康保险"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="deferredPensionInsurance"
            label="税延养老保险"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="otherAmount" label="其他" align="center">
          </el-table-column>
          <el-table-column
            prop="allowTaxDeduction"
            label="允许扣除的税费"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="taxSaving" label="减免税额" align="center">
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">待申报</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已申报</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn"
                  @click="Invoicing(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  提交申报
                </div>
                <div class="operateBtn" @click="goDetail(scope.row)">
                  查看明细
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="从业人员劳务报酬所得税"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-select v-model="status" placeholder="请选择">
          <el-option label="申报成功" value="1"> </el-option>
          <el-option label="申报失败" value="0"> </el-option>
        </el-select>
        <div style="margin-top: 20px" v-if="status == '0'">失败描述：</div>
        <el-input
          v-if="status == '0'"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="failDesc"
          style="margin-top: 5px"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confrim">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose1"
    >
      <div style="height: 350px;overflow-y: scroll;">
        <div v-for="(item, index) in errorList" :key="index">{{ item }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system
  },
  data() {
    return {
      leftList: this.Plugins.taxData(),
      ruleForm: {
        name: "",
        status: "0",
        phone: "",
        mounth: "",
        year: "2025"
      },
      tableData: [],
      errorList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      multipleTable: [],
      failDesc: "",
      dialogVisible: false,
      dialogVisible1: false,
      selectData: {},
      status: "",
      type: "0" //0 单独数据处理   1批量数据确认
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    dowon() {
      window.open(
        "http://down.baoanlailou.com/file/excel/template-劳务报酬所得（适用累计预扣法）.xls"
      );
    },
    goDetail(val) {
      this.$router.push({
        path: "/laborDetail",
        query: {
          id: val.taxBatchNo
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.status = "0";
      this.failDesc = "";
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },
    exportList() {
      if (this.ruleForm.mounth == "") {
        this.$message({
          message: "请选择月份",
          type: "warning"
        });
        return;
      }
      let arr = [];
      if (this.multipleTable.length != 0) {
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
      }
      let param = {
        ids: arr,
        page: this.page,
        pageSize: this.pageSize,
        month: this.ruleForm.mounth,
        year: this.ruleForm.year,
        name: this.ruleForm.name,
        phone: this.ruleForm.phone,
        status: this.ruleForm.status
      };
      this.$axios
        .post("/admapi/tax/work/export", param, { responseType: "blob" })
        .then(data => {
          console.log(data);
          this.$refs.multipleTable.clearSelection();
          let val = new Blob([data.data], {
            type: "application/vnd.ms-excel;charset=utf-8"
          });
          let header = decodeURI(data.headers["content-disposition"]);
          // console.log(header);
          let index = header.indexOf("''");
          let fileName = header.substring(index + 2, header.length);
          console.log(fileName);
          const url = window.URL.createObjectURL(val);
          const link = document.createElement("a");
          link.download = fileName; // 设置a标签的下载属性
          link.style.display = "none";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
          document.body.removeChild(link);
        })
        .catch()
        .finally();
      // );
    },
    InvoicingAll() {
      let arr = [];
      if (this.multipleTable.length != 0) {
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
      } else {
        this.$message({
          message: "请选择申报数据",
          type: "warning"
        });
        return;
      }
      this.$confirm("请确认是否进行批量申报操作", "操作提醒", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post(`/admapi/tax/work/batchsubmit`, {
              ids: arr
            })
            .then(({ data }) => {
              this.$message({
                message: "申报成功",
                type: "success"
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    confrim() {
      if (this.status == "") {
        return;
      }
      if (this.status == "0") {
        if (this.failDesc == "") {
          this.$message({
            message: "请输入失败原因",
            type: "warning"
          });
          return;
        }
      }
      if (this.type == "0") {
        let param = {
          id: this.selectData.id,
          state: this.status,
          failDesc: this.failDesc
        };
        this.$axios
          .post(`/admapi/withdraw/tempconfirm`, param)
          .then(({ data }) => {
            this.$message({
              message: "确认成功",
              type: "success"
            });
            this.dialogVisible = false;
            this.getList();
          })
          .catch()
          .finally();
      } else {
        if (this.multipleTable.length == 0) {
          this.$message({
            message: "请选择确认数据",
            type: "warning"
          });
          return;
        }
        let arr = [];
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
        let param = {
          ids: arr,
          state: this.status,
          failDesc: this.failDesc
        };
        this.$axios
          .post(`/admapi/withdraw/tempbatchconfirm`, param)
          .then(({ data }) => {
            console.log(data);
            if (data.errorCount != 0) {
              this.errorList = data.errorMessages;
              this.dialogVisible1 = true;
            } else {
              this.$message({
                message: "批量确认成功",
                type: "success"
              });
            }
            this.multipleTable = [];
            this.$refs.multipleTable.clearSelection();
            this.getList();
            this.dialogVisible = false;
          })
          .catch()
          .finally();
      }
    },
    Invoicing(val) {
      this.$confirm("请确认是否进行申报操作", "操作提醒", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post(`/admapi/tax/work/submit`, {
              id: val.id
            })
            .then(({ data }) => {
              this.$message({
                message: "申报成功",
                type: "success"
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "0";
      this.ruleForm.phone = "";
      this.ruleForm.mounth = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        month: this.ruleForm.mounth,
        year: this.ruleForm.year,
        name: this.ruleForm.name,
        phone: this.ruleForm.phone,
        status: this.ruleForm.status
      };
      this.$axios
        .post(`/admapi/tax/work/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    }
  }
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
